import { styled } from '../stitches.config'

export const CheckIcon = styled('div', {
    width: '60%',
    height: '60%',
    margin: '20%',
    backgroundColor: '#3353FF',
    borderRadius: 3,
})
